export const QUERY_UTM_COOKIE = 'query_utm'
export const QUERY_UTM_COOKIE_DAYS = 30
export const COOKIE_DOMAIN = '.appbooster.com'

const SEARCH_ENGINES = [
  [/(^|\.)google\./, 'google'],
  [/(^|\.)yandex\./, 'yandex'],
  [/(^|\.)ya\.ru$/, 'yandex'],
  [/(^|\.)bing\.com$/, 'bing'],
  [/(^|\.)duckduckgo\.com$/, 'duckduckgo'],
  [/(^|\.)yahoo\./, 'yahoo'],
  [/(^|\.)ecosia\.org$/, 'ecosia'],
  [/(^|\.)baidu\.com$/, 'baidu'],
  [/(^|\.)naver\.com$/, 'naver'],
  [/(^|\.)brave\.com$/, 'brave'],
]

export const getSearchEngine = (referrer) => {
  try {
    const host = new URL(referrer).hostname
    const match = SEARCH_ENGINES.find(([pattern]) => pattern.test(host))

    return match && match[1]
    // eslint-disable-next-line no-empty
  } catch (error) {}
}

export const collectTouch = ({ search, referrer, pathname }) => {
  if (search.includes('utm')) {
    return Object.fromEntries(new URLSearchParams(search))
  }

  const engine = getSearchEngine(referrer)
  if (engine) {
    return { utm_source: engine, utm_medium: 'organic', utm_content: pathname }
  }

  return {}
}
